import { useMemo } from "react";
import type { DataGridTotals } from "./types";

const CLIENT_TOTALS: DataGridTotals = { source: "client" };

/**
 * Where the totals row gets its numbers: server-provided values when given,
 * otherwise sums of the loaded rows. Server-paged and infinite tables without
 * server values get `undefined` (no totals row), since a page sum isn't a total.
 */
export const useTotals = ({
    values,
    isPartial,
}: {
    values: Partial<Record<string, number>> | undefined;
    isPartial: boolean;
}): DataGridTotals | undefined =>
    useMemo(() => {
        if (values) {
            return { source: "server", values };
        }
        return isPartial ? undefined : CLIENT_TOTALS;
    }, [values, isPartial]);
